module.exports = __webpack_public_path__ + "static/media/rebirth_sample_12.f85af50c.jpg";